//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// web-app-wrapper imports
import { WebAppNav } from "#webapp/src/components/web-app-nav";
import { jwt } from "#webapp/src/state/local-storage";
import { getCurrentOrg } from "#webapp/src/util/org.util";
import { webAppWrapperFragments, webAppWrapperQuery } from "./WebAppWrapper.gql";
import * as s from "./WebAppWrapper.styles";
import { IContainer, IProps, IState } from "./WebAppWrapperTypes";

// components
import Div100vh from "react-div-100vh";
// state
import { withRouteQuery } from "#webapp/src/routing/routes.util";
import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
import { isImpersonated } from "@clockwise/client-commons/src/util/jwt";
import {
  getRenderTimeZone,
  setCurrentTimeZone,
  setRenderTimeZone,
} from "@clockwise/web-commons/src/util/time-zone.util";

//////////////////
// COMPONENT
//////////////////
class WebAppWrapperCmpt extends React.Component<IProps, IState> {
  static defaultProps = {
    navChildren: null,
  };

  constructor(props: IProps) {
    super(props);
  }

  public componentDidMount() {
    // detect sudo and timezone change
    const org = getCurrentOrg(this.props.viewer);
    if (
      isImpersonated(jwt.get()) &&
      org &&
      org.userWorkingHours &&
      org.userWorkingHours.workingHours.timeZone &&
      (getRenderTimeZone() !== org.userWorkingHours.workingHours.timeZone ||
        getRenderTimeZone() !== org.userWorkingHours.workingHours.timeZone)
    ) {
      window.alert(`Changing time zone to ${org.userWorkingHours.workingHours.timeZone}`);
      setRenderTimeZone(org.userWorkingHours.workingHours.timeZone);
      setCurrentTimeZone(org.userWorkingHours.workingHours.timeZone);
    }
  }

  private renderContainer = () => {
    return (
      <div style={s.container}>
        {!this.props.hideNav ? (
          <WebAppNav
            hideMenu={this.props.hideMenu}
            hideLogo={this.props.hideLogo}
            hideAdvancedMenu={this.props.hideAdvancedMenu}
            viewer={this.props.viewer}
            onClickMenu={this.props.onClickMenu}
          >
            {this.props.navChildren}
          </WebAppNav>
        ) : null}
        <div style={s.body}>{this.props.children}</div>
      </div>
    );
  };

  public render() {
    return this.props.dontUseV100 ? (
      this.renderContainer()
    ) : (
      <Div100vh>{this.renderContainer()}</Div100vh>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const WebAppWrapperRedux = connect(mapStateToProps, {})(WebAppWrapperCmpt);

//////////////////
// RELAY
//////////////////
export const WebAppWrapper = createFragmentContainer(WebAppWrapperRedux, webAppWrapperFragments);

export const WebAppWrapperPage = withRouteQuery(WebAppWrapper, webAppWrapperQuery);
